// extracted by mini-css-extract-plugin
module.exports = {"disabledButton":"components_disabledButton__dWclc","image":"components_image__2d7Uq"};